import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-TrashbinShape",
  "use": "svg-icon-TrashbinShape-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-TrashbinShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.357 2.432c.07-.294.2-.842.324-.932l2.663-.012c.125.102.26.658.332.956.04.173.087.363.146.556H4.208c.063-.202.108-.397.149-.568zM9.437 3c-.113-.128-.231-.61-.303-.908C8.934 1.26 8.63 0 7.363 0H4.68C3.394 0 3.083 1.306 2.898 2.085c-.069.289-.197.827-.304.915H.75v1.5h1.5v5.989c0 .834.665 1.511 1.5 1.511h4.489c.834 0 1.511-.677 1.511-1.511V4.5h1.5V3H9.437z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol